import request from "../utils/request";

const ASSET_API = {
    getAssetById: async (id) => {
        return request.get("/assets/id/" + id).then((response) => response.data);
    },
};

export default ASSET_API;
